<template>
  <v-content class="pa-12">
    <v-layout justify-space-around>
      <v-flex d-flex justify-start align-center style="color: #3E7662;font-weight: bold;font-size: 24px;">
        <span>งานวิจัยทั้งหมด</span>
      </v-flex>
    </v-layout>
    <!--search-->
    <v-row>
      <v-col cols="3">
        <v-text-field placeholder="รหัสโครงการวิจัย" color="#3e7662" dense outlined v-model="searchData.researchCode"
          hide-details />
      </v-col>
      <v-col cols="3">
        <v-text-field placeholder="ชื่อ นามสกุล ผู้วิจัย" color="#3e7662" dense outlined
          v-model="searchData.researcherName" hide-details />
      </v-col>
      <v-col cols="3">
        <v-text-field placeholder="เลขรับ" color="#3e7662" dense outlined v-model="searchData.initialNumber"
          hide-details />
      </v-col>
      <v-col cols="3">
        <v-text-field placeholder="รหัส CREC/YMID" color="#3e7662" dense outlined v-model="searchData.ymidname"
          hide-details />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <v-select hide-details clearable :menu-props="{ bottom: true, offsetY: true }" background-color="#3e7662" dark
          solo flat dense label="สถานะงานวิจัย" :items="statusList" item-text="name" item-value="name"
          v-model="searchData.status" />
      </v-col>
      <v-col cols="3">
        <v-select hide-details clearable :menu-props="{ bottom: true, offsetY: true }" background-color="#3e7662" dark
          solo flat dense label="ประเภทการพิจารณา" :items="considerationType" item-text="name" item-value="id"
          v-model="searchData.considerationType_id" />
      </v-col>
      <v-col cols="3">
        <v-text-field placeholder="ชื่อโครงการวิจัย" color="#3e7662" dense outlined v-model="searchData.researchName"
          hide-details />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <DateInputForm :model="dateChange.startDate" @update-data="updateDate('startDate', $event)" label="ตั้งแต่">
        </DateInputForm>
      </v-col>
      <v-col cols="3">
        <DateInputForm :model="dateChange.endDate" @update-data="updateDate('endDate', $event)" label="จนถึง">
        </DateInputForm>
      </v-col>
      <v-col class="shrink d-flex justify-end">
        <v-btn color="#3e7662" dark @click="search(1)">
          <span class="font-weight-bold">ค้นหา</span>
        </v-btn>
      </v-col>
      <v-col class="text-right">
        <v-btn class="rounded-pill" color="#57b140" dark @click="exportFile()">
          <span class="font-weight-bold">Export Excel</span>
        </v-btn>
      </v-col>
    </v-row>

    <!--    <v-layout my-6 justify-space-around>-->
    <!--      <v-flex shrink mr-6 d-flex justify-start align-center style="font-weight: bold;">-->
    <!--        <span>กรองประเภท</span>-->
    <!--      </v-flex>-->
    <!--      <v-flex d-flex justify-start align-center style="color: #3E7662;">-->
    <!--        <v-radio-group hide-details v-model="filterType" row>-->
    <!--          <v-radio @click.native="checkFilterRadio('1')" :class="checkRadioFilter1 ? 'radio-checked' : ''" color="#3E7662" label="1. ประเภท Full Board" value="1"></v-radio>-->
    <!--          <v-radio @click.native="checkFilterRadio('2')" :class="checkRadioFilter2 ? 'radio-checked' : ''" color="#3E7662" label="2. ประเภท Expedited" value="2"></v-radio>-->
    <!--          <v-radio @click.native="checkFilterRadio('3')" :class="checkRadioFilter3 ? 'radio-checked' : ''" color="#3E7662" label="3. ประเภท Exemption" value="3"></v-radio>-->
    <!--          <v-radio @click.native="checkFilterRadio('4')" :class="checkRadioFilter4 ? 'radio-checked' : ''" color="#3E7662" label="4. ทั้งหมด" value="4"></v-radio>-->
    <!--        </v-radio-group>-->
    <!--      </v-flex>-->
    <!--    </v-layout>-->

    <!-- Table -->
    <v-layout>
      <v-flex>
        <form-table :headers="headers" :items="researchList" onViewData :editConsiderResult="editConsiderResult"
          :cancelResearchCode="cancelResearchCode" :onMailResend="onMailResend"></form-table>
        <!--                <form-table-->
        <!--                        :headers="headers"-->
        <!--                        :items="researchList"-->
        <!--                        on-view-->
        <!--                        onCheck-->
        <!--                        onEditResearch-->
        <!--                        :editConsiderResult="editConsiderResult"-->
        <!--                ></form-table>-->
      </v-flex>
    </v-layout>
    <!-- Pagination -->
    <v-layout mt-12>
      <v-flex>
        <v-pagination color="#3E7662" :length="paginateResearch.last_page" :total-visible="9" @input="search($event)"
          v-model="paginateResearch.current_page"></v-pagination>
        <!--        <v-pagination-->
        <!--          color="#3E7662"-->
        <!--          :length="paginateSearch.last_page"-->
        <!--          :total-visible="9"-->
        <!--          @input="search"-->
        <!--          v-model="paginateSearch.current_page"-->
        <!--        ></v-pagination>-->
      </v-flex>
    </v-layout>

    <!-- Modal Edit Consider Result -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="considerResultDialog" persistent max-width="800px" :scrollable="considerResultForm.considerResult ===
          'ผ่านการพิจารณาและรอประธานอนุมัติ'
          ">
          <v-card>
            <!-- Header -->
            <v-card-title class="mb-4">
              <span class="font-weight-medium font-weight-bold">แก้ไขผลการพิจารณา</span>
            </v-card-title>
            <v-card-text>
              <!-- row 1 -->
              <v-layout px-6>
                <v-flex xs3 mr-3 justify-end align-center d-flex>
                  <span style="font-weight: bold;">ชื่องานวิจัย</span>
                </v-flex>
                <v-flex justify-start align-center d-flex>
                  <v-text-field v-model="considerResultForm.nameResearch" color="#3E7662" readonly outlined dense
                    hide-details />
                </v-flex>
              </v-layout>
              <!-- row 2 -->
              <v-layout mt-6 px-6>
                <v-flex xs3 mr-3 justify-end align-center d-flex>
                  <span style="font-weight: bold;">ผลการพิจารณา </span>
                </v-flex>
                <v-flex xs9 pt-4 class="field-select">
                  <v-select clearable :menu-props="{ bottom: true, offsetY: true }" background-color="#3E7662" solo flat
                    dense @change="checkSelected()" label="เลือกผลการพิจารณา" :items="considerResultList"
                    item-text="name" item-value="name" v-model="considerResultForm.considerResult"></v-select>
                </v-flex>
              </v-layout>

              <div v-if="considerResultForm.considerResult ===
                'ผ่านการพิจารณาและรอประธานอนุมัติ'
              ">
                <v-divider class="my-6"></v-divider>

                <v-layout class="mt-8 px-6">
                  <v-flex class="text-start">
                    <span style="font-weight: bold;font-size: 18px;">กำหนดการส่งรายงานความก้าวหน้า</span>
                  </v-flex>
                </v-layout>
                <v-layout class="px-6">
                  <v-flex justify-start align-center d-flex>
                    <v-radio-group hide-details v-model="considerResultForm.month">
                      <v-row>
                        <v-col cols="auto">
                          <v-radio @click.native="checkRadio('1')" :class="checkRadio1 ? 'radio-checked' : ''"
                            color="#3E7662" label="6 เดือน" value="6"></v-radio>
                        </v-col>
                        <v-col cols="auto">
                          <v-radio @click.native="checkRadio('2')" :class="checkRadio2 ? 'radio-checked' : ''"
                            color="#3E7662" label="1 ปี" value="12"></v-radio>
                        </v-col>
                        <v-col cols="auto">
                          <v-radio @click.native="checkRadio('3')" :class="checkRadio3 ? 'radio-checked' : ''"
                            color="#3E7662" label="อื่นๆ ระบุ" value="other"></v-radio>
                        </v-col>
                        <v-col cols="2" class="text-field-center">
                          <v-text-field type="number" :disabled="considerResultForm.month !== 'other'" color="#3E7662"
                            class="mt-n5" v-model="considerResultForm.otherMonth" hide-details />
                        </v-col>
                        <v-col cols="auto">
                          <span class="font-weight-bold">เดือน</span>
                        </v-col>
                      </v-row>
                    </v-radio-group>
                  </v-flex>
                </v-layout>

                <v-layout class="mt-8 px-6">
                  <v-flex class="text-start">
                    <span style="font-weight: bold;font-size: 18px;">กำหนดการอนุมัติงานวิจัย</span>
                  </v-flex>
                </v-layout>
                <v-layout class="px-6">
                  <v-flex justify-start align-center d-flex>
                    <DateInputForm :model="approvalDate" @update-data="updateDate('approvalDate', $event)">
                    </DateInputForm>
                  </v-flex>
                </v-layout>

                <v-divider class="my-6"></v-divider>
                <!--รับรอง รับทราบเอกสาร-->
                <v-layout class="my-8 px-6">
                  <v-flex class="text-start">
                    <span style="font-weight: bold;font-size: 18px;">รับรอง & รับทราบ เอกสาร</span>
                  </v-flex>
                </v-layout>

                <v-layout mb-2>
                  <v-flex shrink mx-1><span style="font-weight: bold">รับรอง</span></v-flex>
                  <v-flex shrink mx-1><span style="font-weight: bold">รับทราบ</span></v-flex>
                  <v-flex class="justify-end text-right" style="font-weight: bold">
                    เปลี่ยนชื่อเอกสาร
                  </v-flex>
                  <v-flex xs3></v-flex>
                </v-layout>

                <div v-for="(file, k) in fileList" :key="'a' + k">
                  <v-layout pl-4 v-if="file.path" class="justify-start text-left">
                    <v-flex class="justify-start">
                      <p class="one-line" style="color: black">
                        {{ file.fileName }}
                      </p>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="file.path" mt-2>
                    <v-flex row ml-2 xs8>
                      <v-checkbox :id="'guaranteeFile' + k" @click.native="
                        checkboxClick('informedFile', file.value)
                        " v-model="guaranteeFile" color="#3e7662" :value="file.value" class="mx-1"></v-checkbox>
                      <v-checkbox :id="'informedFile' + k" @click.native="
                        checkboxClick('guaranteeFile', file.value)
                        " v-model="informedFile" color="#3e7662" :value="file.value" class="mx-2"></v-checkbox>
                      <a :href="file.path" style="color: #3e7662;" target="_blank">
                        <p class="d-flex mt-1 one-line">
                          {{
                            file.name.length > 40
                              ? file.name.substring(0, 40) + "..."
                              : file.name
                          }}
                        </p>
                      </a>
                    </v-flex>
                    <v-flex>
                      <v-checkbox color="#3e7662" v-model="file.isChangeName"
                        @click="toggleChangeName(file)"></v-checkbox>
                    </v-flex>
                    <v-flex ml-4>
                      <v-text-field color="#3e7662" :disabled="!file.isChangeName" outlined dense
                        v-model="file.newNameTh" placeholder="ตั้งชื่อเอกสาร ภาษาไทย"></v-text-field>
                      <v-text-field color="#3e7662" :disabled="!file.isChangeName" outlined dense
                        v-model="file.newNameEn" placeholder="ตั้งชื่อเอกสาร ภาษาอังกฤษ"></v-text-field>
                    </v-flex>
                  </v-layout>
                </div>

                <v-layout class="my-8 px-6">
                  <v-flex class="text-start">
                    <span style="font-weight: bold;font-size: 18px;">รับรอง & รับทราบ เอกสารอื่นๆ</span>
                  </v-flex>
                </v-layout>
                <v-layout mb-3>
                  <v-flex shrink mx-1><span style="font-weight: bold">รับรอง</span></v-flex>
                  <v-flex shrink mx-1><span style="font-weight: bold">รับทราบ</span></v-flex>
                </v-layout>
                <v-layout v-for="(otherFile, index) in otherFileList" :key="index">
                  <v-flex row ml-2 xs8>
                    <v-checkbox @click.native="
                      checkboxClick('informedOtherFile', otherFile.value)
                      " v-model="guaranteeOtherFile" color="#3e7662" :value="otherFile.value"
                      class="mx-1"></v-checkbox>
                    <v-checkbox @click.native="
                      checkboxClick('guaranteeOtherFile', otherFile.value)
                      " v-model="informedOtherFile" color="#3e7662" :value="otherFile.value" class="mx-2"></v-checkbox>
                    <a :href="otherFile.path" style="color: #3e7662;" target="_blank">
                      <span class="mt-1">{{ otherFile.fileName }}</span>
                    </a>
                  </v-flex>
                  <v-flex>
                    <v-checkbox color="#3e7662" v-model="otherFile.isChangeName"
                      @click="toggleChangeName(otherFile)"></v-checkbox>
                  </v-flex>
                  <v-flex ml-4>
                    <v-text-field color="#3e7662" :disabled="!otherFile.isChangeName" outlined dense
                      v-model="otherFile.newNameTh" placeholder="ตั้งชื่อเอกสาร ภาษาไทย"></v-text-field>
                    <v-text-field color="#3e7662" :disabled="!otherFile.isChangeName" outlined dense
                      v-model="otherFile.newNameEn" placeholder="ตั้งชื่อเอกสาร ภาษาอังกฤษ"></v-text-field>
                  </v-flex>
                </v-layout>
              </div>

              <div v-if="considerResultForm.considerResult ===
                'ปรับปรุงแก้ไขเพื่อรับรอง' ||
                considerResultForm.considerResult ===
                'ปรับปรุงแก้ไขเพื่อพิจารณาใหม่' ||
                considerResultForm.considerResult ===
                'ไม่รับรอง หรือ ไม่อนุมัติ'
              ">
                <v-divider class="my-6"></v-divider>

                <v-layout class="mt-8 px-6">
                  <v-flex class="text-start">
                    <span style="font-weight: bold;font-size: 18px;">NOTE</span>
                  </v-flex>
                </v-layout>
                <v-layout class="px-6">
                  <v-flex justify-start align-center d-flex>
                    <TextareaForm hide-detail :model="considerResultForm.note"
                      @update-data="updateData('note', $event)">
                    </TextareaForm>
                  </v-flex>
                </v-layout>

                <v-layout class="mt-8 px-6">
                  <v-flex class="text-start">
                    <span style="font-weight: bold;font-size: 18px;">ไฟล์แนบ </span><span
                      style="font-size: 14px;color: red">*ใช้สกุลไฟล์ PDF เท่านั้น</span>
                  </v-flex>
                </v-layout>
                <v-layout class="px-6">
                  <v-flex justify-start align-center d-flex>
                    <v-layout px-12 mt-4>
                      <v-flex d-flex justify-start align-center style="text-align: left;font-weight: bold">
                        <v-file-input accept=".pdf" prepend-icon="" hide-details :model="considerResultForm.file"
                          label="กรุณาเลือกไฟล์ PDF" outlined dense color="#3E7662" clearable background-color="#FBF6F3"
                          append-icon="attach_file" @change="uploadFile($event)"></v-file-input>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="font-weight: bold" color="#3E7662" text @click="closeModal">
                Close
              </v-btn>
              <v-btn style="font-weight: bold" color="#3E7662" text @click="previewMail">Preview Mail
              </v-btn>
              <v-btn style="font-weight: bold" color="#3E7662" text @click="previewCOA">Preview COA
              </v-btn>
              <v-btn style="font-weight: bold" color="#3E7662" text @click="updateConsiderResult">Sent
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <loading color="#527281" :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
  </v-content>
</template>

<script>
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import FormTable from "../../components/table/FormTable";
import DateInputForm from "../../components/input/DateInputForm";
import TextareaForm from "../../components/input/TextareaForm";
import FileInputForm from "../../components/input/FileInputForm";
import { mapState, mapActions } from "vuex";
import { domain } from "../../services/Constants";
import axios from "axios";
import { read, utils, writeFileXLSX } from "xlsx";
export default {
  components: {
    FormTable,
    Loading,
    DateInputForm,
    FileInputForm,
    TextareaForm,
  },
  data: () => ({
    exportExcelList: [],
    searchData: {
      checkPaginate: "",
      startDate: "",
      endDate: "",
      researchCode: "",
      researcherName: "",
      status: "",
      considerationType_id: "0",
      considerationType: "0",
      initialNumber: "",
      isResubmission: "0",
      researchName: "",
      ymidname: "",
    },
    considerResultDialog: false,
    considerResultList: [
      { id: 1, name: "ผ่านการพิจารณาและรอประธานอนุมัติ" },
      { id: 2, name: "ปรับปรุงแก้ไขเพื่อรับรอง" },
      { id: 3, name: "ปรับปรุงแก้ไขเพื่อพิจารณาใหม่" },
      { id: 4, name: "ไม่รับรอง หรือ ไม่อนุมัติ" },
    ],
    statusList: [
      { id: 1, name: "ผ่านการพิจารณา" },
      { id: 2, name: "ปรับปรุงแก้ไขเพื่อรับรอง" },
      { id: 3, name: "ปรับปรุงแก้ไขเพื่อพิจารณาใหม่" },
      { id: 4, name: "ไม่รับรอง หรือ ไม่อนุมัติ" },
      { id: 6, name: "อนุมัติ" },
      { id: 7, name: "อยู่ระหว่างการพิจารณา" },
      { id: 8, name: "งานวิจัยที่ปิดโครงการ" },
    ],
    considerationType: [
      { id: "0", value: "0", name: "ทั้งหมด", isResubmission: "0" },
      { id: "1", value: "1", name: "ประเภท Full Board", isResubmission: "0" },
      { id: "2", value: "2", name: "ประเภท Expedited", isResubmission: "0" },
      { id: "3", value: "3", name: "ประเภท Exemption", isResubmission: "0" },
      {
        id: "4",
        value: "1",
        name: "ประเภท Full Board (แก้ไขเพื่อรับรอง)",
        isResubmission: "1",
      },
      {
        id: "5",
        value: "2",
        name: "ประเภท Expedited (แก้ไขเพื่อรับรอง)",
        isResubmission: "1",
      },
    ],
    considerResultForm: {
      id: "",
      nameResearch: "",
      considerResult: "",
      month: "",
      otherMonth: "",
      approvalDate: "",
      note: "",
      file: "",
      guaranteeFile: [],
      guaranteeOtherFile: [],
    },
    approvalDate: "",
    checkRadio1: false,
    checkRadio2: false,
    checkRadio3: false,
    paginateResearch: {
      current_page: 1,
      from: 1,
      last_page: 1,
      per_page: 1,
      total: 1,
      to: 1,
    },
    paginateSearch: {
      current_page: 1,
      from: 1,
      last_page: 1,
      per_page: 1,
      total: 1,
      to: 1,
    },
    filterType: "1",
    checkRadioFilter1: false,
    checkRadioFilter2: false,
    checkRadioFilter3: false,
    checkRadioFilter4: false,
    headers: [
      {
        text: "ลำดับ",
        value: "number",
        align: "center",
        sortable: false,
        class: "header-data-table",
      },
      {
        text: "ชื่องานวิจัย",
        value: "researchName",
        align: "center",
        sortable: false,
        width: "20%",
      },
      {
        text: "ชื่อผู้วิจัย",
        value: "researcherName",
        align: "center",
        sortable: false,
        width: "20%",
      },
      {
        text: "วันที่อนุมัติ",
        value: "approvalDate",
        align: "center",
        sortable: false,
      },
      { text: "สถานะ", value: "status", align: "center", sortable: false },
      {
        text:
          "เลขรับ (Initial), รหัสโครงการวิจัย, ประเภทการพิจารณา, รหัส CREC/YMID",
        value: "initial",
        align: "center",
        sortable: false,
      },
      { text: "ดูแบบประเมิน", value: "view", align: "center", sortable: false },
      { text: "ดูข้อมูล", value: "view", align: "center", sortable: false },
      { text: "ดูประวัติ", value: "view", align: "center", sortable: false },
      {
        text: "แก้ไขผลการพิจารณา",
        value: "edit",
        align: "center",
        sortable: false,
      },
      {
        text: "เปลี่ยนประเภทการพิจารณา",
        value: "back",
        align: "center",
        sortable: false,
      },
    ],
    fileList: [
      {
        value: "guarantyFile",
        path: "",
        fileName:
          "หนังสือรับรองจากผู้บังคับบัญชาระดับ ผอ.กอง หรือ หัวหน้าภาควิชา",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "researchFile",
        path: "",
        fileName: "เอกสารโครงร่างงานวิจัย",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "ro01_1File",
        path: "",
        fileName: "หนังสือข้อตกลงรักษาความลับของข้อมูลฯ (RO01_1.1_2560)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "ro01_2File",
        path: "",
        fileName: "หนังสือข้อตกลงในการดำเนินการวิจัย (RO01_2_2560)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "crecFile",
        path: "",
        fileName:
          "เอกสารรับรองโครงร่างการวิจัย จาก CREC/YMID (initial submission)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "editPointFile",
        path: "",
        fileName:
          "เอกสารแสดงจุดแก้ไข (กรณีแก้ไขโครงร่างงานวิจัย หลังพิจารณาแล้ว)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "dataRecordFrom",
        path: "",
        fileName: "แบบบันทึกข้อมูล",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "questionnaireInterview",
        path: "",
        fileName: "แบบสอบถามหรือสัมภาษณ์",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "diary",
        path: "",
        fileName: "สมุดบันทึก (diary) ",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "documentsExplain",
        path: "",
        fileName:
          "เอกสารชี้แจงข้อมูลผู้ร่วมโครงการวิจัย /หนังสือแสดงเจตนา ภาษาไทย",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "otherDocuments",
        path: "",
        fileName:
          "เอกสารอื่นๆ ได้แก่ โฆษณา สิ่งตีพิมพ์ บทความ สื่อ เช่น วิดีโอ ซีดี เทป",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "certificate",
        path: "",
        fileName:
          "สำเนาหนังสือรับรองว่า ได้ผ่านการสอบโครงร่างการวิจัยจากคณะ /สถาบันแล้ว",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "investigatorBrochure",
        path: "",
        fileName: "คู่มือผู้วิจัย (Investigator brochure)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "researchFileClean",
        path: "",
        fileName: "เอกสารโครงร่างงานวิจัย (Clean Version)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "researchFileHighlight",
        path: "",
        fileName: "เอกสารโครงร่างงานวิจัย (Highlight Version)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "ro01_1FileClean",
        path: "",
        fileName:
          "หนังสือข้อตกลงรักษาความลับของข้อมูลฯ (RO01_1.1_2560) (Clean Version)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "ro01_1FileHighlight",
        path: "",
        fileName:
          "หนังสือข้อตกลงรักษาความลับของข้อมูลฯ (RO01_1.1_2560) (Highlight Version)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "ro01_2FileClean",
        path: "",
        fileName:
          "หนังสือข้อตกลงในการดำเนินการวิจัย (RO01_2_2560) (Clean Version)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "ro01_2FileHighlight",
        path: "",
        fileName:
          "หนังสือข้อตกลงในการดำเนินการวิจัย (RO01_2_2560) (Highlight Version)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "considerResultFile",
        path: "",
        fileName: "เอกสารแสดงผลการพิจารณา",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "crecFile2",
        path: "",
        fileName: "เอกสารรับรองโครงร่างการวิจัย จาก CREC/YMID (re submission)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "dataRecordFromClean",
        path: "",
        fileName: "แบบบันทึกข้อมูล (Clean Version)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "questionnaireInterviewClean",
        path: "",
        fileName: "แบบสอบถามหรือสัมภาษณ์ (Clean Version)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "diaryClean",
        path: "",
        fileName: "สมุดบันทึก (diary) (Clean Version)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "dataRecordFromHighlight",
        path: "",
        fileName: "แบบบันทึกข้อมูล (Highlight Version)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "questionnaireInterviewHighlight",
        path: "",
        fileName: "แบบสอบถามหรือสัมภาษณ์ (Highlight Version)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "diaryHighlight",
        path: "",
        fileName: "สมุดบันทึก (diary) (Highlight Version)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "documentsExplainClean",
        path: "",
        fileName:
          "เอกสารชี้แจงข้อมูลผู้ร่วมโครงการวิจัย /หนังสือแสดงเจตนา (Clean Version)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "otherDocuments2",
        path: "",
        fileName:
          "เอกสารอื่นๆ ได้แก่ โฆษณา สิ่งตีพิมพ์ บทความ สื่อ เช่น วิดีโอ ซีดี เทป (re submission)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "certificate2",
        path: "",
        fileName:
          "สำเนาหนังสือรับรองว่า ได้ผ่านการสอบโครงร่างการวิจัยจากคณะ /สถาบันแล้ว (re submission)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "investigatorBrochure2",
        path: "",
        fileName: "คู่มือผู้วิจัย (Investigator brochure) (re submission)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "researcherProfile",
        path: "",
        fileName: "แบบประวัติผู้วิจัย/ผู้ร่วม/ที่ปรึกษา (RF 10_2563)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "submitReportForConsider",
        path: "",
        fileName: "แบบรายงานการส่งโครงร่างวิจัยเพื่อพิจารณา",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "researcherProfile",
        path: "",
        fileName: "แบบประวัติผู้วิจัย/ผู้ร่วม/ที่ปรึกษา (RF 10_2563)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "submitReportForConsider2",
        path: "",
        fileName: "แบบรายงานการส่งโครงร่างวิจัยเพื่อพิจารณา",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "documentsExplainHighlight",
        path: "",
        fileName:
          "เอกสารชี้แจงข้อมูลผู้ร่วมโครงการวิจัย /หนังสือแสดงเจตนา (Highlight Version)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "submitReportForConsiderClean",
        path: "",
        fileName: "แบบรายงานการส่งโครงร่างวิจัยเพื่อพิจารณา(Clean Version)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
      {
        value: "submitReportForConsiderHighlight",
        path: "",
        fileName: "แบบรายงานการส่งโครงร่างวิจัยเพื่อพิจารณา(Highlight Version)",
        name: "",
        newNameTh: "",
        newNameEn: "",
        isChangeName: false,
      },
    ],
    otherFileList: [],
    isLoading: false,
    fullPage: true,
    researchList: [],
    textareaFrom: null,
    guaranteeFile: [],
    informedFile: [],
    guaranteeOtherFile: [],
    informedOtherFile: [],
    rows: [
      { Name: "Bill Clinton", Index: 42 },
      { Name: "GeorgeW Bush", Index: 43 },
      { Name: "Barack Obama", Index: 44 },
      { Name: "Donald Trump", Index: 45 },
      { Name: "Joseph Biden", Index: 46 },
    ],
    dateChange: {
      startDate: "",
      endDate: "",
    },
  }),
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
      role: (state) => state.Auth.role,
    }),
  },
  created() {
    // Check Permission Access
    if (this.role !== 1 && this.role !== 4) {
      this.$router.go(-1);
    }
    // this.getResearchList(1)
    this.search(1);
  },
  methods: {
    closeModal() {
      this.considerResultDialog = false;
      this.guaranteeFile = [];
      this.informedFile = [];
      this.otherFileList = [];
      this.guaranteeOtherFile = [];
      this.informedOtherFile = [];
      this.fileList = [
        {
          value: "guarantyFile",
          path: "",
          fileName:
            "หนังสือรับรองจากผู้บังคับบัญชาระดับ ผอ.กอง หรือ หัวหน้าภาควิชา",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "researchFile",
          path: "",
          fileName: "เอกสารโครงร่างงานวิจัย",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "ro01_1File",
          path: "",
          fileName: "หนังสือข้อตกลงรักษาความลับของข้อมูลฯ (RO01_1.1_2560)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "ro01_2File",
          path: "",
          fileName: "หนังสือข้อตกลงในการดำเนินการวิจัย (RO01_2_2560)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "crecFile",
          path: "",
          fileName:
            "เอกสารรับรองโครงร่างการวิจัย จาก CREC/YMID (initial submission)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "editPointFile",
          path: "",
          fileName:
            "เอกสารแสดงจุดแก้ไข (กรณีแก้ไขโครงร่างงานวิจัย หลังพิจารณาแล้ว)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "dataRecordFrom",
          path: "",
          fileName: "แบบบันทึกข้อมูล",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "questionnaireInterview",
          path: "",
          fileName: "แบบสอบถามหรือสัมภาษณ์",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "diary",
          path: "",
          fileName: "สมุดบันทึก (diary) ",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "documentsExplain",
          path: "",
          fileName:
            "เอกสารชี้แจงข้อมูลผู้ร่วมโครงการวิจัย /หนังสือแสดงเจตนา ภาษาไทย",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "otherDocuments",
          path: "",
          fileName:
            "เอกสารอื่นๆ ได้แก่ โฆษณา สิ่งตีพิมพ์ บทความ สื่อ เช่น วิดีโอ ซีดี เทป",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "certificate",
          path: "",
          fileName:
            "สำเนาหนังสือรับรองว่า ได้ผ่านการสอบโครงร่างการวิจัยจากคณะ /สถาบันแล้ว",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "investigatorBrochure",
          path: "",
          fileName: "คู่มือผู้วิจัย (Investigator brochure)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "researchFileClean",
          path: "",
          fileName: "เอกสารโครงร่างงานวิจัย (Clean Version)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "researchFileHighlight",
          path: "",
          fileName: "เอกสารโครงร่างงานวิจัย (Highlight Version)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "ro01_1FileClean",
          path: "",
          fileName:
            "หนังสือข้อตกลงรักษาความลับของข้อมูลฯ (RO01_1.1_2560) (Clean Version)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "ro01_1FileHighlight",
          path: "",
          fileName:
            "หนังสือข้อตกลงรักษาความลับของข้อมูลฯ (RO01_1.1_2560) (Highlight Version)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "ro01_2FileClean",
          path: "",
          fileName:
            "หนังสือข้อตกลงในการดำเนินการวิจัย (RO01_2_2560) (Clean Version)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "ro01_2FileHighlight",
          path: "",
          fileName:
            "หนังสือข้อตกลงในการดำเนินการวิจัย (RO01_2_2560) (Highlight Version)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "considerResultFile",
          path: "",
          fileName: "เอกสารแสดงผลการพิจารณา",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "crecFile2",
          path: "",
          fileName:
            "เอกสารรับรองโครงร่างการวิจัย จาก CREC/YMID (re submission)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "dataRecordFromClean",
          path: "",
          fileName: "แบบบันทึกข้อมูล (Clean Version)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "questionnaireInterviewClean",
          path: "",
          fileName: "แบบสอบถามหรือสัมภาษณ์ (Clean Version)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "diaryClean",
          path: "",
          fileName: "สมุดบันทึก (diary) (Clean Version)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "dataRecordFromHighlight",
          path: "",
          fileName: "แบบบันทึกข้อมูล (Highlight Version)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "questionnaireInterviewHighlight",
          path: "",
          fileName: "แบบสอบถามหรือสัมภาษณ์ (Highlight Version)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "diaryHighlight",
          path: "",
          fileName: "สมุดบันทึก (diary) (Highlight Version)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "documentsExplainClean",
          path: "",
          fileName:
            "เอกสารชี้แจงข้อมูลผู้ร่วมโครงการวิจัย /หนังสือแสดงเจตนา (Clean Version)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "otherDocuments2",
          path: "",
          fileName:
            "เอกสารอื่นๆ ได้แก่ โฆษณา สิ่งตีพิมพ์ บทความ สื่อ เช่น วิดีโอ ซีดี เทป (re submission)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "certificate2",
          path: "",
          fileName:
            "สำเนาหนังสือรับรองว่า ได้ผ่านการสอบโครงร่างการวิจัยจากคณะ /สถาบันแล้ว (re submission)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "investigatorBrochure2",
          path: "",
          fileName: "คู่มือผู้วิจัย (Investigator brochure) (re submission)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "researcherProfile",
          path: "",
          fileName: "แบบประวัติผู้วิจัยหลัก (RF 10_2563)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "submitReportForConsider",
          path: "",
          fileName: "แบบรายงานการส่งโครงร่างวิจัยเพื่อพิจารณา",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "researcherProfile",
          path: "",
          fileName: "แบบประวัติผู้วิจัยหลัก (RF 10_2563)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "submitReportForConsider2",
          path: "",
          fileName: "แบบรายงานการส่งโครงร่างวิจัยเพื่อพิจารณา",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "documentsExplainHighlight",
          path: "",
          fileName:
            "เอกสารชี้แจงข้อมูลผู้ร่วมโครงการวิจัย /หนังสือแสดงเจตนา (Highlight Version)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "submitReportForConsiderClean",
          path: "",
          fileName: "แบบรายงานการส่งโครงร่างวิจัยเพื่อพิจารณา(Clean Version)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
        {
          value: "submitReportForConsiderHighlight",
          path: "",
          fileName:
            "แบบรายงานการส่งโครงร่างวิจัยเพื่อพิจารณา(Highlight Version)",
          name: "",
          newNameTh: "",
          newNameEn: "",
          isChangeName: false,
        },
      ];
    },
    search(page) {
      this.isLoading = true;
      this.searchData.page = page;
      let considerType = this.considerationType.find(
        (x) => x.id === this.searchData.considerationType_id
      );
      this.searchData.isResubmission = considerType.isResubmission;
      this.searchData.considerationType = considerType.value;
      this.$store
        .dispatch("Research/searchResearchCode", this.searchData)
        .then((res) => {
          this.setData(res);
        })
        .catch((e) => {
          console.log("e", e);
          this.isLoading = false;
          Swal.fire({
            title: "ไม่พบงานวิจัย",
            icon: "error",
            position: "center",
            confirmButtonText: "ตกลง",
            confirmButtonColor: "#3E7662",
          }).then(() => {
            this.searchData = {
              startDate: "",
              endDate: "",
              researchCode: "",
              researcherName: "",
              researchName: "",
              status: "",
              considerationType_id: "0",
              considerationType: "0",
              initialNumber: "",
              isResubmission: "0",
              ymidname: "",
            };
            this.search(1);
          });
        });
    },
    getResearchList() {
      this.$store
        .dispatch("Research/getResearchList", this.searchData)
        .then((res) => {
          this.setData(res);
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    async updateConsiderResult() {
      this.isLoading = true;
      await this.reName();
      if (
        this.considerResultForm.considerResult !==
        "ผ่านการพิจารณาและรอประธานอนุมัติ"
      ) {
        this.considerResultForm.month = "";
        this.considerResultForm.otherMonth = "";
      } else {
        this.considerResultForm.guaranteeFile = this.guaranteeFile;
        this.considerResultForm.guaranteeOtherFile = this.guaranteeOtherFile;
        this.considerResultForm.informedFile = this.informedFile;
        this.considerResultForm.informedOtherFile = this.informedOtherFile;
      }
      this.$store
        .dispatch("Research/updateConsiderResult", this.considerResultForm)
        .then((res) => {
          Swal.fire({
            title: "อัพเดตเรียบร้อยแล้ว",
            icon: "success",
            position: "center",
            showConfirmButton: false,
            background: "#D8D8D8",
            timer: 3000,
          });
          this.considerResultDialog = false;
          this.isLoading = false;
          this.search(1);
        })
        .catch((e) => {
          console.log(e);
          Swal.fire({
            title: "เกิดข้อผิดพลาด",
            text: "อัพเดตไม่สำเร็จ",
            icon: "warning",
          });
          this.isLoading = false;
        });
    },
    async previewCOA() {
      this.isLoading = true;
      await this.reName();
      this.considerResultForm.guaranteeFile = this.guaranteeFile;
      this.considerResultForm.guaranteeOtherFile = this.guaranteeOtherFile;
      this.considerResultForm.informedFile = this.informedFile;
      this.considerResultForm.informedOtherFile = this.informedOtherFile;
      this.$store
        .dispatch("Research/previewCOA", this.considerResultForm)
        .then((res) => {
          window.open(res);
          // this.considerResultDialog = false;
          this.isLoading = false;
          // this.search(1);
        })
        .catch((e) => {
          console.log(e);
          Swal.fire({
            title: "เกิดข้อผิดพลาด",
            text: e.response.data.message,
            icon: "warning",
          });
          this.isLoading = false;
        });
    },
    editConsiderResult(item) {
      this.considerResultForm.note = "";
      this.considerResultDialog = true;
      this.considerResultForm.id = item.id;
      this.considerResultForm.nameResearch = item.data.thResearchName;
      this.considerResultForm.considerResult = item.data.considerResult;
      let newLine = "\r\n";
      let count = 0;
      if (item.version == 1 && item.isManual == 0) {
        this.fileList[0].path = item.data.guarantyFilePath;
        this.fileList[0].name = item.data.guarantyFile;
        if (item.data.guarantyFilePath) this.informedFile.push("guarantyFile");
        this.fileList[1].path = item.data.researchFilePath;
        this.fileList[1].name = item.data.researchFile;
        if (item.data.researchFilePath) this.informedFile.push("researchFile");
        this.fileList[2].path = item.data.ro01_1FilePath;
        this.fileList[2].name = item.data.ro01_1File;
        if (item.data.ro01_1FilePath) this.informedFile.push("ro01_1File");
        this.fileList[3].path = item.data.ro01_2FilePath;
        this.fileList[3].name = item.data.ro01_2File;
        if (item.data.ro01_2FilePath) this.informedFile.push("ro01_2File");
        this.fileList[4].path = item.data.crecFilePath;
        this.fileList[4].name = item.data.crecFile;
        if (item.data.crecFilePath) this.informedFile.push("crecFile");
        // this.fileList[5].path = item.data.editPointFilePath;
        // this.fileList[5].name = item.data.editPointFile;
        // if (item.data.editPointFilePath)
        //   this.informedFile.push("editPointFile");
        this.fileList[6].path = item.data.dataRecordFromPath;
        this.fileList[6].name = item.data.dataRecordFrom;
        if (item.data.dataRecordFromPath)
          this.informedFile.push("dataRecordFrom");
        this.fileList[7].path = item.data.questionnaireInterviewPath;
        this.fileList[7].name = item.data.questionnaireInterview;
        if (item.data.questionnaireInterviewPath)
          this.informedFile.push("questionnaireInterview");
        this.fileList[8].path = item.data.diaryPath;
        this.fileList[8].name = item.data.diary;
        if (item.data.diaryPath) this.informedFile.push("diary");
        this.fileList[9].path = item.data.documentsExplainPath;
        this.fileList[9].name = item.data.documentsExplain;
        if (item.data.documentsExplainPath)
          this.informedFile.push("documentsExplain");
        this.fileList[10].path = item.data.otherDocumentsPath;
        this.fileList[10].name = item.data.otherDocuments;
        if (item.data.otherDocumentsPath)
          this.informedFile.push("otherDocuments");
        this.fileList[11].path = item.data.certificatePath;
        this.fileList[11].name = item.data.certificate;
        if (item.data.certificatePath) this.informedFile.push("certificate");
        this.fileList[12].path = item.data.investigatorBrochurePath;
        this.fileList[12].name = item.data.investigatorBrochure;
        if (item.data.investigatorBrochurePath)
          this.informedFile.push("investigatorBrochure");
        this.fileList[31].path = item.data.researcherProfilePath;
        this.fileList[31].name = item.data.researcherProfile;
        if (item.data.researcherProfilePath)
          this.informedFile.push("researcherProfile");
        this.fileList[32].path = item.data.submitReportForConsiderPath;
        this.fileList[32].name = item.data.submitReportForConsider;
        if (item.data.submitReportForConsiderPath)
          this.informedFile.push("submitReportForConsider");
      } else {
        this.fileList[0].path = item.data.guarantyFilePath;
        this.fileList[0].name = item.data.guarantyFile;
        if (item.data.guarantyFilePath) this.informedFile.push("guarantyFile");
        this.fileList[13].path = item.data.researchFileCleanPath;
        this.fileList[13].name = item.data.researchFileClean;
        if (item.data.researchFileClean)
          this.informedFile.push("researchFileClean");
        this.fileList[14].path = item.data.researchFileHighlightPath;
        this.fileList[14].name = item.data.researchFileHighlight;
        if (item.data.researchFileHighlight)
          this.informedFile.push("researchFileHighlight");
        this.fileList[15].path = item.data.ro01_1FileCleanPath;
        this.fileList[15].name = item.data.ro01_1FileClean;
        if (item.data.ro01_1FileClean)
          this.informedFile.push("ro01_1FileClean");
        this.fileList[16].path = item.data.ro01_1FileHighlightPath;
        this.fileList[16].name = item.data.ro01_1FileHighlight;
        if (item.data.ro01_1FileHighlight)
          this.informedFile.push("ro01_1FileHighlight");
        this.fileList[17].path = item.data.ro01_2FileCleanPath;
        this.fileList[17].name = item.data.ro01_2FileClean;
        if (item.data.ro01_2FileClean)
          this.informedFile.push("ro01_2FileClean");
        this.fileList[18].path = item.data.ro01_2FileHighlightPath;
        this.fileList[18].name = item.data.ro01_2FileHighlight;
        if (item.data.ro01_2FileHighlight)
          this.informedFile.push("ro01_2FileHighlight");
        this.fileList[19].path = item.data.considerResultFilePath;
        this.fileList[19].name = item.data.considerResultFile;
        if (item.data.considerResultFile)
          this.informedFile.push("considerResultFile");
        this.fileList[20].path = item.data.crecFile2Path;
        this.fileList[20].name = item.data.crecFile2;
        if (item.data.crecFile2) this.informedFile.push("crecFile2");
        this.fileList[5].path = item.data.editPointFilePath;
        this.fileList[5].name = item.data.editPointFile;
        if (item.data.editPointFilePath)
          this.informedFile.push("editPointFile");
        this.fileList[21].path = item.data.dataRecordFromCleanPath;
        this.fileList[21].name = item.data.dataRecordFromClean;
        if (item.data.dataRecordFromCleanPath)
          this.informedFile.push("dataRecordFromClean");
        this.fileList[22].path = item.data.questionnaireInterviewCleanPath;
        this.fileList[22].name = item.data.questionnaireInterviewClean;
        if (item.data.questionnaireInterviewCleanPath)
          this.informedFile.push("questionnaireInterviewClean");
        this.fileList[23].path = item.data.diaryCleanPath;
        this.fileList[23].name = item.data.diaryClean;
        if (item.data.diaryCleanPath) this.informedFile.push("diaryClean");
        this.fileList[24].path = item.data.dataRecordFromHighlightPath;
        this.fileList[24].name = item.data.dataRecordFromHighlight;
        if (item.data.dataRecordFromHighlightPath)
          this.informedFile.push("dataRecordFromHighlight");
        this.fileList[25].path = item.data.questionnaireInterviewHighlightPath;
        this.fileList[25].name = item.data.questionnaireInterviewHighlight;
        if (item.data.questionnaireInterviewHighlightPath)
          this.informedFile.push("questionnaireInterviewHighlight");
        this.fileList[26].path = item.data.diaryHighlightPath;
        this.fileList[26].name = item.data.diaryHighlight;
        if (item.data.diaryHighlightPath)
          this.informedFile.push("diaryHighlight");
        this.fileList[27].path = item.data.documentsExplainCleanPath;
        this.fileList[27].name = item.data.documentsExplainClean;
        if (item.data.documentsExplainCleanPath)
          this.informedFile.push("documentsExplainClean");
        this.fileList[28].path = item.data.otherDocuments2Path;
        this.fileList[28].name = item.data.otherDocuments2;
        if (item.data.otherDocuments2Path)
          this.informedFile.push("otherDocuments2");
        this.fileList[29].path = item.data.certificate2Path;
        this.fileList[29].name = item.data.certificate2;
        if (item.data.certificate2Path) this.informedFile.push("certificate2");
        this.fileList[30].path = item.data.investigatorBrochure2Path;
        this.fileList[30].name = item.data.investigatorBrochure2;
        if (item.data.investigatorBrochure2Path)
          this.informedFile.push("investigatorBrochure2");
        this.fileList[33].path = item.data.researcherProfilePath;
        this.fileList[33].name = item.data.researcherProfile;
        if (item.data.researcherProfilePath)
          this.informedFile.push("researcherProfile");
        this.fileList[34].path = item.data.submitReportForConsider2Path;
        this.fileList[34].name = item.data.submitReportForConsider2;
        if (item.data.submitReportForConsider2Path)
          this.informedFile.push("submitReportForConsider2");
        this.fileList[35].path = item.data.documentsExplainHighlightPath;
        this.fileList[35].name = item.data.documentsExplainHighlight;
        if (item.data.documentsExplainHighlightPath)
          this.informedFile.push("documentsExplainHighlight");
        this.fileList[36].path = item.data.submitReportForConsiderCleanPath;
        this.fileList[36].name = item.data.submitReportForConsiderClean;
        if (item.data.submitReportForConsiderCleanPath)
          this.informedFile.push("submitReportForConsiderClean");
        this.fileList[37].path = item.data.submitReportForConsiderHighlightPath;
        this.fileList[37].name = item.data.submitReportForConsiderHighlight;
        if (item.data.submitReportForConsiderHighlightPath)
          this.informedFile.push("submitReportForConsiderHighlight");
      }
      let relatedDocCount = 0;
      if (item.data.relatedDocuments) {
        item.data.relatedDocuments.forEach((doc) => {
          if (doc.name) {
            console.log("doc", doc);

            this.otherFileList.push({
              value: relatedDocCount,
              fileName: doc.name ? doc.name : "ไม่มีชื่อ",
              path: doc.filePath,
              isChangeName: "",
              newNameTh: "",
              newNameEn: "",
            });
            this.informedOtherFile.push(relatedDocCount);
            relatedDocCount++;
          }
        });
      } else {
        this.otherFileList = [];
      }
      if (item.data.r_o03_1) {
        item.data.r_o03_1.forEach((ro03_1) => {
          console.log("ro03_1.adviceEthical", ro03_1.adviceEthical);
          this.considerResultForm.note =
            this.considerResultForm.note +
            "คนที่" +
            ro03_1.order +
            " (RO_03_1) : " +
            newLine +
            "ข้อเสนอแนะเพิ่มเติมในส่วนของวิธีการดําเนินการวิจัย (Scientific Assessment) : " +
            newLine +
            (ro03_1.adviceResearcher ? "- " + ro03_1.adviceResearcher : "-") +
            newLine +
            "ข้อเสนอแนะเพิ่มเติมประเด็นจริยธรรมการวิจัย (Ethical Issue) : " +
            newLine +
            (ro03_1.adviceEthical ? "- " + ro03_1.adviceEthical : "-") +
            newLine +
            "ข้อเสนอแนะเพิ่มเติมกระบวนการขอความยินยอม (Informed Consent Process) : " +
            newLine +
            (ro03_1.adviceProcess ? "- " + ro03_1.adviceProcess : "-") +
            newLine +
            "ข้อเสนอแนะเพิ่มเติมเอกสารชี้แจงข้อมูลอาสาสมัคร (Information sheet) : " +
            newLine +
            (ro03_1.adviceDoc ? "- " + ro03_1.adviceDoc : " -") +
            newLine +
            "ข้อเสนอแนะเพิ่มเติมอื่นๆ : " +
            newLine +
            (ro03_1.adviceResearch ? "- " + ro03_1.adviceResearch : "-") +
            newLine +
            newLine;
          count = ro03_1.order;
        });
      }
      let ro04_1 = item.data.r_o04_1;
      if (ro04_1) {
        this.considerResultForm.note =
          this.considerResultForm.note +
          "คนที่" +
          ro04_1.order +
          " (RO_04_1) : " +
          newLine +
          "- ข้อคิดเห็นและแนะนำ(การมีผลประโยชน์ทับซ้อน) : " +
          newLine +
          (ro04_1.adviceTextBox ? "- " + ro04_1.adviceTextBox : "-") +
          newLine +
          "- ข้อคิดเห็นและเสนอแนะเพิ่มเติม: " +
          newLine +
          (ro04_1.adviceTextBox2 ? "- " + ro04_1.adviceTextBox2 : "-") +
          newLine;
      }

      let researcherCount = 0;
      console.log(item.data.researcher_and_adviser);
      if (item.data.researcher_and_adviser) {
        item.data.researcher_and_adviser.forEach((doc) => {
          if (doc.historyFilePath) {
            let fileName =
              "แบบประวัติ" +
              doc.position +
              " " +
              doc.user.thName +
              " (RF 10_2563)";
            this.fileList.push({
              value: fileName,
              fileName: fileName,
              path: doc.historyFilePath,
              name: doc.historyFile,
              isChangeName: false,
              newNameTh: "",
              newNameEn: "",
            });
            this.informedFile.push(fileName);
            researcherCount++;
          }
        });
      }
      console.log("FileList", this.fileList);
      console.log("otherFile.path", this.otherFileList);
    },
    cancelResearchCode(item) {
      Swal.fire({
        title: "คุณต้องการเปลี่ยนประเภทการพิจารณาใช่หรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        cancelButtonText: "ไม่ต้องการ",
        confirmButtonText: "ต้องการ",
      }).then((result) => {
        console.log(result);
        // this.isLoading = true;
        if (result.value) {
          this.$store.dispatch("Research/cancelResearchCode", item).then((res) => {
            this.isLoading = false;
            Swal.fire({
              position: "center",
              icon: "success",
              title: "บันทึกสำเร็จ",
              showConfirmButton: false,
              timer: 1500,
            }).then(() => {
              this.search(1);
            });
          })
            .catch((e) => {
              Swal.fire({
                title: "Save failed!",
                text: "บันทึกไม่สำเร็จ",
                icon: "warning",
              }).then(() => {
                this.isLoading = false;
              });
            });
        }
        this.isLoading = false;
      });
    },
    checkConsiderType(val) {
      if (val === 1) {
        return "Full Board";
      } else if (val === 2) {
        return "Expedited";
      } else {
        return "Exemption";
      }
    },
    checkRadio(name) {
      if (name === "1") {
        this.checkRadio1 = true;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.considerResultForm.otherMonth = "";
      }
      if (name === "2") {
        this.checkRadio1 = false;
        this.checkRadio2 = true;
        this.checkRadio3 = false;
        this.considerResultForm.otherMonth = "";
      }
      if (name === "3") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = true;
        // this.filterType = '3';
      }
    },
    checkSelected() {
      if (
        this.considerResultForm.considerResult !==
        "ผ่านการพิจารณาและรอประธานอนุมัติ"
      ) {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.considerResultForm.otherMonth = "";
      }
    },
    updateData(name, val) {
      this.considerResultForm[name] = val;
    },
    isRead(data) {
      let notRead = false;
      data.forEach((reviewer) => {
        if (reviewer.isRead === 0) {
          notRead = true;
        }
      });
      return notRead;
    },
    updateDate(name, val) {
      if (name === "approvalDate") {
        this.considerResultForm.approvalDate = val.date;
        this.approvalDate = this.changeDate(val.date);
      } else {
        this.searchData[name] = val.date;
        this.dateChange[name] = this.changeDate(val.date);
      }
    },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);

      sub_year = parseInt(sub_year) + 543;

      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    checkboxClick(checkboxName, value) {
      let index = this[checkboxName].indexOf(value);
      if (index > -1) {
        this[checkboxName].splice(index, 1);
      }
    },
    reName() {
      this.fileList.forEach((file) => {
        if (file.isChangeName === true) {
          let index = this.guaranteeFile.indexOf(file.value);
          if (index > -1) {
            if (file.newNameTh !== "" || file.newNameEn !== "")
              this.guaranteeFile[index] = {
                th: file.newNameTh,
                en: file.newNameEn,
              };
          }
        }
      });
      this.otherFileList.forEach((file) => {
        if (file.isChangeName === true) {
          let index = this.guaranteeOtherFile.indexOf(file.value);
          if (index > -1) {
            if (file.newNameTh !== "" || file.newNameEn !== "")
              this.guaranteeOtherFile[index] = {
                th: file.newNameTh,
                en: file.newNameEn,
              };
          }
        }
      });
      this.fileList.forEach((file) => {
        if (file.isChangeName === true) {
          let index = this.informedFile.indexOf(file.value);
          if (index > -1) {
            if (file.newNameTh !== "" || file.newNameEn !== "")
              this.informedFile[index] = {
                th: file.newNameTh,
                en: file.newNameEn,
              };
          }
        }
      });
      this.otherFileList.forEach((file) => {
        if (file.isChangeName === true) {
          let index = this.informedOtherFile.indexOf(file.value);
          if (index > -1) {
            if (file.newNameTh !== "" || file.newNameEn !== "")
              this.informedOtherFile[index] = {
                th: file.newNameTh,
                en: file.newNameEn,
              };
          }
        }
      });
    },
    uploadFile(val) {
      this.isLoading = true;
      // this.considerResultForm.file = val;
      var formData = new FormData();
      formData.append("considerResultFile", val);
      axios
        .post(domain + "/api/upload-file-pre", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.considerResultForm.file = response.data.fileName;
          this.considerResultForm.filePath = response.data.filePath;
          this.isLoading = false;
        })
        .catch(function (error) {
          console.log("error", error);
          this.isLoading = false;
        });
    },
    onMailResend(id) {
      Swal.fire({
        title: "ท่านต้องการส่งอีเมลอีกครั้งหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ต้องการ",
        cancelButtonText: "ยกเลิก",
      }).then((res) => {
        if (res.value) {
          this.isLoading = true;
          let payload = { id: id, email_type: "considerResult" };
          this.$store
            .dispatch("Research/researchEmailResend", payload)
            .then((res) => {
              this.isLoading = false;
              Swal.fire({
                position: "center",
                icon: "success",
                title: "ส่งอีเมลซ้ำเรียบร้อยแล้ว",
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((e) => {
              Swal.fire({
                icon: "error",
                title: "เกิดข้อผิดพลาด",
                text: e.response.data.message,
                confirmButtonColor: "#3E7662",
              });
              this.isLoading = false;
            });
        }
      });
    },
    async previewMail() {
      this.isLoading = true;
      await this.reName();
      if (
        this.considerResultForm.considerResult !==
        "ผ่านการพิจารณาและรอประธานอนุมัติ"
      ) {
        this.considerResultForm.month = "";
        this.considerResultForm.otherMonth = "";
      } else {
        this.considerResultForm.guaranteeFile = this.guaranteeFile;
        this.considerResultForm.guaranteeOtherFile = this.guaranteeOtherFile;
        this.considerResultForm.informedFile = this.informedFile;
        this.considerResultForm.informedOtherFile = this.informedOtherFile;
      }
      this.$store
        .dispatch("Research/previewConsiderResultMail", this.considerResultForm)
        .then((res) => {
          var pageLink = "about:blank";
          var pwa = window.open(pageLink, "_new");
          pwa.document.open();
          pwa.document.write(res);
          pwa.document.close();
          this.isLoading = false;
        })
        .catch((e) => {
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาด",
            text: e.response.data.message,
            confirmButtonColor: "#3E7662",
          });
          this.isLoading = false;
        });
    },
    setData(res) {
      this.researchList = [];
      let i = 1;
      res.data.forEach((data) => {
        let order1 = "";
        let order2 = "";
        let order3 = "";
        let isOrder1 = 0;
        let isOrder2 = 0;
        let isOrder3 = 0;
        data.choose_reviewer.forEach((reviewer) => {
          if (reviewer.sequence === 1) {
            isOrder1 = reviewer.user ? reviewer.user.thName : "";
          } else if (reviewer.sequence === 2) {
            isOrder2 = reviewer.user ? reviewer.user.thName : "";
          } else if (reviewer.sequence === 3) {
            isOrder3 = reviewer.user ? reviewer.user.thName : "";
          }
        });
        data.r_o03_1.forEach((ro03) => {
          if (ro03 && ro03.order === 1) {
            order1 =
              "/form-ro-03?id=" +
              ro03.researchID +
              "&order=" +
              ro03.order +
              "&researchType=" +
              this.checkConsiderType(data.considerType) +
              "&isRead=true";
          } else {
            order2 =
              "/form-ro-03?id=" +
              ro03.researchID +
              "&order=" +
              ro03.order +
              "&researchType=" +
              this.checkConsiderType(data.considerType) +
              "&isRead=true";
          }
        });
        if (data.r_o04_1 && data.r_o04_1.order === 2) {
          order2 =
            "/form-ro-04-1?id=" +
            data.r_o04_1.researchID +
            "&order=" +
            data.r_o04_1.order +
            "&isRead=true";
        } else if (data.r_o04_1 && data.r_o04_1.order === 3) {
          order3 =
            "/form-ro-04-1?id=" +
            data.r_o04_1.researchID +
            "&order=" +
            data.r_o04_1.order +
            "&isRead=true";
        }
        this.researchList.push({
          number: i,
          researchName: data.thResearchName,
          researcherName: data.user.preNameTh
            ? data.user.preNameTh + " " + data.user.thName
            : data.user.thName,
          approvalDate: data.approvalDate ? data.approvalDate : "-",
          version: data.version ? data.version : "-",
          status: data.status,
          isManual: data.isManual,
          readStatus:
            data.choose_reviewer.length === 0
              ? true
              : this.isRead(data.choose_reviewer),
          considerResult: data.considerResult ? data.considerResult : "-",
          initial: data.initialNumber ? data.initialNumber : "-",
          code: data.researchCode ? data.researchCode : "-",
          type: data.research_type,
          ymidname: data.ymidname ? data.ymidname : "-",
          id: data.id,
          order1: order1,
          order2: order2,
          order3: order3,
          isOrder1: isOrder1,
          isOrder2: isOrder2,
          isOrder3: isOrder3,
          form: "AllResearch",
          linkView: "FormResearch1",
          onView: 10,
          data: data,
          mailLink:
            domain + "research-email/" + data.id + "?email_type=approve",
          researcher_and_adviser: data.researcher_and_adviser,
          ro03_4FilePath: data.ro03_4FilePath,
        });
        i++;
      });
      this.paginateResearch.current_page = res.current_page;
      this.paginateResearch.from = res.from;
      this.paginateResearch.last_page = res.last_page;
      this.paginateResearch.per_page = res.per_page;
      this.paginateResearch.total = res.total;
      this.paginateResearch.to = res.to;
      this.isLoading = false;
    },
    toggleChangeName(file) {
      if (!file.isChangeName) {
        file.newNameTh = "";
        file.newNameEn = "";
      }
    },
    exportFile() {
      this.searchData.checkPaginate = "noPaginate";
      this.isLoading = true;
      let considerType = this.considerationType.find(
        (x) => x.id === this.searchData.considerationType_id
      );
      this.searchData.isResubmission = considerType.isResubmission;
      this.searchData.considerationType = considerType.value;
      this.$store
        .dispatch("Research/searchResearchCode", this.searchData)
        .then((res) => {
          console.log("res eiei", res);
          let dataXLSX = [];
          res.forEach((data, i) => {
            dataXLSX.push({
              ลำดับ: i + 1,
              ชื่องานวิจัย: data.thResearchName,
              ชื่อผู้วิจัย: data.user.preNameTh,
              วันที่อนุมัติ: data.approvalDate ?? "-",
              สถานะ: data.status,
              "เลขรับ(Inital)": data.initialNumber ?? "-",
              รหัสโครงการวิจัย: data.researchCode ?? "-",
              ประเภทการพิจารณา: data.research_type ?? "-",
              "ชื่ออนุกรรมการประเมิน (คนที่ 1)": data?.choose_reviewer[0]?.user?.thName ?? "-",
              "ชื่ออนุกรรมการประเมิน (คนที่ 2)": data?.choose_reviewer[1]?.user?.thName ?? "-",
              "ชื่ออนุกรรมการประเมิน (คนที่ 3)": data?.choose_reviewer[2]?.user?.thName ?? "-",
            });
          });
          const ws = utils.json_to_sheet(dataXLSX);
          const wb = utils.book_new();
          utils.book_append_sheet(wb, ws, "Data");
          writeFileXLSX(wb, "AllResearch.xlsx");
          this.isLoading = false;
        })
        .catch((e) => {
          console.log("e", e);
          this.isLoading = false;
          Swal.fire({
            title: "ไม่สามารถ export excel ได้",
            icon: "error",
            position: "center",
            confirmButtonText: "ตกลง",
            confirmButtonColor: "#3E7662",
          }).then(() => {
            this.searchData = {
              startDate: "",
              endDate: "",
              researchCode: "",
              researcherName: "",
              researchName: "",
              status: "",
              considerationType_id: "0",
              considerationType: "0",
              initialNumber: "",
              isResubmission: "0",
              ymidname: "",
              checkPaginate: "",
            };
          });
        });
    },
  },
};
</script>

<style lang="scss">
.header-data-table {
  font-size: 20px;
}
</style>
